<template>
  <div class="app-main">
    <!-- <div class="poster-title">长按图片保存你的专属渠道</div> -->
    <img v-if="imgresUrl" :src="imgresUrl" />
      <div style="margin: 16px;">
        <p>长按图片进行保存</p>
        <!-- <van-button round
                    block
                    type="info"
                    class="butland"
                    native-type="submit">长按保存海报</van-button> -->
      </div>
  </div>
</template>

<script>
import {
  outputPosterFile
} from '@/api/poster'
import {
  BlobToBase64
} from '@/util/file-blob-base64.js'
export default {
  name: 'PosterResult',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      posterResUrl: '',
      channelId: '',
      imgId: '',
      insuredUrl: '',
      imgresUrl: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    console.log(this.$route.query)
    this.createPoster()
  },
  mounted() { 
     console.log(this.$route.query)
  },
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() { },
  methods: {
    // 生成海报
   async createPoster(){
        const loadinng = this.$toast({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中...'
      })
       try {
        const res = await outputPosterFile(this.$route.query)
        console.log(res)
        let posterResUrl = await BlobToBase64(res.data)
        this.imgresUrl = posterResUrl
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: e.message
        })
      } finally {
        loadinng.close()
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.poster-title {
  width: 80%;
  padding: px2rem(10, 750);
  text-align: center;
  border: 1px dashed $themeColor;
  border-radius: px2rem(20, 750);
  font-size: px2rem(35, 750);
  margin: px2rem(10) auto;
  margin-bottom: px2rem(10);
}
img {
  display: block;
  width: 90%;
  margin: 20px auto;
  -webkit-touch-callout: none;
}
p{
  color: #DB0003;
  text-align: center;
  font-size: 18px;

}
// .butland{
//   height: px2rem(120);
//   background: linear-gradient(to right, #FF6C61 , #DB0003);
//   border-radius:  px2rem(60);
//   border-color: #EDEEF2;
// }
// @import url(); 引入公共css类
</style>
